import type { PlcFault, PlcManufacturerFaultLibrary } from "./types";
import { abbFaultLibrary } from "./abb";
import { automationdirectFaultLibrary } from "./automationdirect";
import { beckhoffFaultLibrary } from "./beckhoff";
import { bosch_rexrothFaultLibrary } from "./bosch-rexroth";
import { br_automationFaultLibrary } from "./br-automation";
import { deltaFaultLibrary } from "./delta";
import { emersonFaultLibrary } from "./emerson";
import { honeywellFaultLibrary } from "./honeywell";
import { keyenceFaultLibrary } from "./keyence";
import { ls_electricFaultLibrary } from "./ls-electric";
import { mitsubishiFaultLibrary } from "./mitsubishi";
import { omronFaultLibrary } from "./omron";
import { panasonicFaultLibrary } from "./panasonic";
import { phoenix_contactFaultLibrary } from "./phoenix-contact";
import { rockwellFaultLibrary } from "./rockwell";
import { schneiderFaultLibrary } from "./schneider";
import { siemensFaultLibrary } from "./siemens";
import { unitronicsFaultLibrary } from "./unitronics";
import { wagoFaultLibrary } from "./wago";

export const plcFaultLibraries: PlcManufacturerFaultLibrary[] = [
  abbFaultLibrary,
  automationdirectFaultLibrary,
  beckhoffFaultLibrary,
  bosch_rexrothFaultLibrary,
  br_automationFaultLibrary,
  deltaFaultLibrary,
  emersonFaultLibrary,
  honeywellFaultLibrary,
  keyenceFaultLibrary,
  ls_electricFaultLibrary,
  mitsubishiFaultLibrary,
  omronFaultLibrary,
  panasonicFaultLibrary,
  phoenix_contactFaultLibrary,
  rockwellFaultLibrary,
  schneiderFaultLibrary,
  siemensFaultLibrary,
  unitronicsFaultLibrary,
  wagoFaultLibrary,
];

export const plcFaults: PlcFault[] =
  plcFaultLibraries.flatMap((library) => library.faults);

export function getPlcFaultsByManufacturer(manufacturerId: string) {
  return plcFaults.filter((fault) => fault.manufacturer_id === manufacturerId);
}

export function getPlcFaultsBySeries(seriesId: string) {
  return plcFaults.filter((fault) => fault.series_id === seriesId);
}

export function getPlcFaultsByModel(
  manufacturerId: string,
  seriesId: string,
  model: string,
) {
  return plcFaults.filter(
    (fault) =>
      fault.manufacturer_id === manufacturerId &&
      fault.series_id === seriesId &&
      fault.model === model,
  );
}
